module.exports = __webpack_public_path__ + "img/icon-6.af342c1e.svg";